import { AuthContext } from 'providers';
import { useBasicBusinessInfo } from 'providers/basic-business-info-provider/BasicBusinessInfoProvider';
import { use, useCallback, useMemo } from 'react';
import { AccessBlock } from 'utils/permissions/access';
import { checkAllowed, mergePermissions } from 'utils/permissions/helpers';

export default function useAuth() {
  const auth = use(AuthContext);

  const { id: businessId } = useBasicBusinessInfo();

  const currentMembership = auth.user?.memberships?.find(
    (m) => m.businessId === Number(businessId),
  );

  const userPermissions = useMemo(
    () =>
      mergePermissions(
        auth.user?.memberships?.find((m) => m.businessId === businessId)?.permissions ?? [],
      ),
    [auth.user?.memberships, businessId],
  );

  const isAllowed = useCallback(
    (permission: AccessBlock[]) => checkAllowed(userPermissions, permission),
    [userPermissions],
  );

  return useMemo(
    () => ({
      ...auth,
      userId: auth?.user?.id,
      employeeId: currentMembership?.employee?.id,
      isAllowed,
    }),
    [auth, currentMembership?.employee?.id, isAllowed],
  );
}
